export enum Size {
  Small = 'small',
  Middle = 'middle',
}

export interface FileIconProps {
  size?: Size;
  type?: string;
  attention?: boolean;
  onClick?: () => void;
}
